<template>
  <div class="about-us">
    <Scrollama @step-enter="stepEnterHandler">
      <div class=" step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation">{{textData.title}}</div>
          <div class="content animation">{{textData.describe}}</div>
          <!--            <div class="btn animation">查看更多</div>-->
        </div>
      </div>
      <div class=" step2" data-step="b">
        <div class="support">
          <div class="first-level-title fnt-32-bold animation" v-show="show1">
            {{serviceTitleList[0].title}}
          </div>
          <div class="content animation" v-show="show1">
            <div class="item-left">
              <div v-for="item in serviceTitleList" :key="item.num" @click="showHandle(item.num)"
                   :class="{'sel-title':showIndex==item.num, 'secondary-title':true }">{{ item.tab }}
              </div>
            </div>
            <div class="item-right">
              <div class="show-content" v-for="item in serviceTitleList" :key="item.num"
                   v-show="showIndex == item.num">
                <div class="secondary-title">{{ item.tab }}</div>
                <div class="text">{{ item.describe }}</div>
                <ul>
                  <li v-for="(item2,index) in 5" :key="index">
                    <img v-if="item['content' + item2]" src="../../../static/images/aboutUs/serviceSupport/jb.png">
                    <div>{{item['content' + item2]}}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" step3" data-step="c">
        <div class="standard">
          <div class="first-level-title animation" v-show="show2">
            {{standardList[0].title}}
          </div>
          <div class="content animation" v-show="show2">
            <div class="item" v-for="(item,index) in standardList" :key="index">
              <div class="secondary-title">{{ item.tab }}</div>
              <div class="text">{{ item.describe }}</div>
              <div class="tat-item">
                <div v-for="(item2,index2) in 4" :key="index2" class="text tag">
                  {{item['content' + item2]}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Scrollama>
    <footer-item></footer-item>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../home/components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      showIndex: 0,
      // 服务支持-左侧标题
      serviceTitleList: [],
      // 服务支持-右侧内容
      serviceContentList: [],
      // 服务标准
      standardList: [],
      textData: {}
    }
  },
  methods: {
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
      }
    },
    showHandle (val) {
      this.showIndex = val
      console.log(this.showIndex)
    }
  },
  mounted: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page501.g501[3]
      this.serviceTitleList = [...this.$boss.page516.g516].reverse().map((item, index) => {
        item.num = index
        return item
      })
      this.standardList = [...this.$boss.page517.g517].reverse()
    }
  }
}
</script>
<style scoped lang="less">
@media screen and (max-width: 1500px) {
  .about-us {
    width: 100%;
    height: 100%;
    font-weight: '微软雅黑';

    div {
      //一级标题
      .first-level-title {
        font-size: 32px;
        font-weight: bold;
        color: #323232;
      }

      //二级标题
      .secondary-title {
        font-size: 24px;
        font-weight: 500;
        color: #323232;
      }

      //正文
      .text {
        font-size: 20px;
        color: #323232;
        margin-top: 70px;
      }

      //背景图宽度保持不变类
      .bg-img-maintain {
        background-size: cover !important;
        background-position: center !important;
      }

      .head {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        height: 71vh;

        img {
          width: 100%;
          height: 100%;
        }

        .title {
          font-size: 52px;
          opacity: 0;
          margin-top: -45vh;
          font-weight: bold;
          color: #fff;
          padding-left: 100px;
        }

        .content {
          padding-left: 100px;
          font-size: 32px;
          opacity: 0;
          margin-top: 40px;
          color: #E6E9F3;
        }

        .btn {
          font-size: 22px;
          margin-top: 110px;
          width: 215px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          color: transparent;
          border: 1px solid transparent;
          margin-bottom: 110px;
        }

      }

      .support {
        border: 1px solid rgba(0, 0, 0, 0);
        width: 100%;
        height: 850px;
        padding: 100px 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .content {
          width: 100%;
          height: 620px;
          display: flex;
          justify-content: center;
          margin-top: 70px;

          .item-left {
            width: 440px;
            height: 100%;
            background: url("../../../static/images/aboutUs/serviceSupport/qhbj.png") no-repeat;

            div {
              height: 155px;
              line-height: 155px;
              width: 440px;
            }

            .sel-title {
              background: url("../../../static/images/aboutUs/serviceSupport/selbg.png") no-repeat;
            }
          }

          .item-right {
            flex: 1;
            background: url("../../../static/images/aboutUs/serviceSupport/bj.png") no-repeat;
            text-align: left;
            padding: 100px;
            box-sizing: content-box;

            .show-content {
              .text {
                margin-top: 30px;
              }

              ul {
                padding: 0;
                margin-top: 70px;
                list-style-type: none;

                li {
                  display: flex;
                  margin-bottom: 40px;

                  img {
                    width: 15px;
                    height: 20px;
                  }

                  div {
                    font-size: 20px;
                    font-weight: 500;
                    margin-left: 20px;
                    height: 20px;
                    line-height: 20px;
                  }
                }
              }

            }
          }
        }

      }

      .standard {
        border: 1px solid rgba(0, 0, 0, 0);
        width: 100%;
        height: 1200px;
        padding: 100px 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .content {
          width: 100%;
          // height: 620px;
          display: flex;
          justify-content: space-between;
          margin-top: 70px;
          flex-wrap: wrap;

          .item {
            background: url("../../../static/images/aboutUs/serviceSupport/standard.png") no-repeat;
            padding: 50px;
            // width: 845px;
            width:42vw;
            height: 410px;
            text-align: left;
            box-sizing: border-box;
            margin-bottom: 20px;

            .text {
              margin-top: 50px;
              width: 100%;
              color: rgba(31, 31, 31, 0.8)
            }

            .tat-item {
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              align-self: flex-start;

              .tag {
                color: #2f6ef6;
                width: 45%;
                height: 41px;
                line-height: 41px;
                background: url("../../../static/images/aboutUs/serviceSupport/k.png") no-repeat;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1501px) {
  .about-us {
    width: 100%;
    height: 100%;
    font-weight: '微软雅黑';

    div {
      //一级标题
      .first-level-title {
        font-size: 32px;
        font-weight: bold;
        color: #323232;
      }

      //二级标题
      .secondary-title {
        font-size: 24px;
        font-weight: 500;
        color: #323232;
      }

      //正文
      .text {
        font-size: 20px;
        color: #323232;
        margin-top: 70px;
      }

      //背景图宽度保持不变类
      .bg-img-maintain {
        background-size: cover !important;
        background-position: center !important;
      }

      .head {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        height: 71vh;

        img {
          width: 100%;
          height: 100%;
        }

        .title {
          font-size: 52px;
          opacity: 0;
          margin-top: -45vh;
          font-weight: bold;
          color: #fff;
          padding-left: 100px;
        }

        .content {
          padding-left: 100px;
          font-size: 32px;
          opacity: 0;
          margin-top: 40px;
          color: #E6E9F3;
        }

        .btn {
          font-size: 22px;
          margin-top: 110px;
          width: 215px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          color: transparent;
          border: 1px solid transparent;
          margin-bottom: 110px;
        }

      }

      .support {
        border: 1px solid rgba(0, 0, 0, 0);
        width: 100%;
        height: 850px;
        padding: 100px 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .content {
          width: 100%;
          height: 620px;
          display: flex;
          justify-content: center;
          margin-top: 70px;

          .item-left {
            width: 440px;
            height: 100%;
            background: url("../../../static/images/aboutUs/serviceSupport/qhbj.png") no-repeat;

            div {
              height: 155px;
              line-height: 155px;
              width: 440px;
            }

            .sel-title {
              background: url("../../../static/images/aboutUs/serviceSupport/selbg.png") no-repeat;
            }
          }

          .item-right {
            flex: 1;
            background: url("../../../static/images/aboutUs/serviceSupport/bj.png") no-repeat;
            text-align: left;
            padding: 100px;
            box-sizing: content-box;

            .show-content {
              .text {
                margin-top: 30px;
              }

              ul {
                padding: 0;
                margin-top: 70px;
                list-style-type: none;

                li {
                  display: flex;
                  margin-bottom: 40px;

                  img {
                    width: 15px;
                    height: 20px;
                  }

                  div {
                    font-size: 20px;
                    font-weight: 500;
                    margin-left: 20px;
                    height: 20px;
                    line-height: 20px;
                  }
                }
              }

            }
          }
        }

      }

      .standard {
        border: 1px solid rgba(0, 0, 0, 0);
        width: 100%;
        height: 1200px;
        padding: 100px 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .content {
          width: 100%;
          // height: 620px;
          display: flex;
          justify-content: space-between;
          margin-top: 70px;
          flex-wrap: wrap;

          .item {
            background: url("../../../static/images/aboutUs/serviceSupport/standard.png") no-repeat;
            padding: 50px;
            width: 845px;
            // width:42vw;
            height: 410px;
            text-align: left;
            box-sizing: border-box;
            margin-bottom: 20px;

            .text {
              margin-top: 50px;
              width: 100%;
              color: rgba(31, 31, 31, 0.8)
            }

            .tat-item {
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              align-self: flex-start;

              .tag {
                color: #2f6ef6;
                width: 45%;
                height: 41px;
                line-height: 41px;
                background: url("../../../static/images/aboutUs/serviceSupport/k.png") no-repeat;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/serviceSupport/serviceSupport.vue